import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M23.8,17.6c-0.3-1.1-1.4-1.7-1.4-1.7s-3-0.8-4-1.2c-0.3-0.1-0.5-0.4-0.7-0.7c1.5-1,2.5-3.1,2.5-5.7c0-3.8-2.1-4.8-4.7-4.8s-4.7,1-4.7,4.8c0,2.6,1,4.6,2.4,5.6c-0.2,0.3-0.4,0.6-0.7,0.7c-0.2,0.1-0.4,0.2-0.7,0.3c-0.3-0.3-0.5-0.5-0.5-0.5s-2.1-0.5-2.8-0.9C8.3,13.4,8.1,13.2,8,13c1-0.7,1.7-2.1,1.7-3.9c0-2.6-1.5-3.3-3.3-3.3S3.3,6.5,3.3,9.2C3.3,11,4,12.4,5,13.1c-0.1,0.2-0.3,0.4-0.5,0.5c-0.7,0.3-2.8,0.9-2.8,0.9S1,14.8,0.8,15.6C0.6,16.3,0.1,17,0,17.1c0.8,0.8,3.7,1.2,6.6,1.2c0.1,0,0.2,0,0.3,0c-0.3,0.7-0.7,1.2-0.8,1.4c1.2,1.2,5.4,1.8,9.5,1.8s8.2-0.6,9.4-1.8C24.8,19.5,24.2,18.6,23.8,17.6" />
    </g>
  </svg>
);
